import { deepBlueA1000 } from "../colors/deepBlue";
export const brandPrimary = "#4050C6";
export const brandSecondary = deepBlueA1000;
